import { propOr } from 'ramda';
import { IPromoText, IRealtyValuation } from '../../types/realtyValuation';

export const getPromoText = (realtyValuation: IRealtyValuation | null): IPromoText | null => {
  return propOr(null, 'promoText', realtyValuation);
};
